export enum RealTimeEventType {
  AppointmentAdded = 'AppointmentAdded',
  AppointmentUpdated = 'AppointmentUpdated',
  AppointmentOrderChanged = 'AppointmentOrderChanged',
  OrderChanged = 'OrderChanged',
  UserNotificationReceived = 'UserNotificationReceived',
  UserTaskAdded = 'UserTaskAdded',
  UserMessageAdded = 'UserMessageAdded',
  PatientMessageAdded = 'PatientMessageAdded',
  PatientAdded = 'PatientAdded',
  InvoiceAdded = 'InvoiceAdded'
}
